export const REPORT_TYPES = Object.freeze({ CODE: 'code', PG: 'pg' })
export const TOKEN_INVALID_MESSAGES = Object.freeze(['请求已过期，请重新请求', '请求IP不一致', '验证码错误次数过多'])
